<template>
  <div class="login-page">
    <app-navbar />
    <div class="wrapper wrapper-full-page">
      <div class="full-page login-page section-image">
        <!--   you can change the color of the filter page using:
        data-color="blue | azure | green | orange | red | purple" -->
        <div class="content">
          <div class="container">
            <div class="col-lg-6 col-md-6 ml-auto mr-auto">
              <card type="login">
                <h3 slot="header" class="header text-center">
                  You do not have permission.
                </h3>
              </card>
            </div>
          </div>
        </div>
        <app-footer />
        <div class="full-page-background" style="background-image: url(static/img/background/background-2.jpg) " />
      </div>
    </div>
  </div>
</template>
<script>
import AppNavbar from 'src/components/Layout/LoginAppNavbar';
import AppFooter from 'src/components/Layout/LoginAppFooter';

export default {
    components: {
        AppNavbar,
        AppFooter
    }
};
</script>
<style>
</style>
